<template>
    <div
        class="im--row"
        :class="`im--theme__${color}`"
    >
        <div class="im--row__cell">
            <button
                type="button"
                class="im--button__simple"
                @click.prevent="onClickButton(row)"
            >
                {{ row.text }}
            </button>
        </div>

        <div
            v-for="(cell, index) in row.cells"
            :key="$uuid.v4(index)"
            class="im--row__cell"
        >
            <button
                type="button"
                class="im--button"
                @click.prevent="onClickButton(cell)"
            >
                <font-awesome-icon icon="angle-right"/>
                {{ cell.heading }}
            </button>
        </div>
    </div>
</template>
<script>

export default ({
    props: ['row','color'],
    methods: {
        onClickButton(content) {
            this.$emit('clicked', content, this.color);
        }
    }
});
</script>
